import { mergeStyleSets, getTheme } from '@fluentui/react';
import type { ITheme } from '@fluentui/react';

const theme: ITheme = getTheme();

export const flagBadgeStyles = mergeStyleSets({
  container: {
    display: 'inline-flex',
    gap: 4,
    flexWrap: 'wrap',
  },
  empty: {
    color: theme.palette.neutralTertiary,
  },
});

export const getFlagBadgeItemStyles = (background: string, color: string) =>
  mergeStyleSets({
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 3,
      padding: '2px 8px',
      borderRadius: 6,
      fontSize: theme.fonts.tiny.fontSize,
      fontWeight: 700,
      backgroundColor: background,
      color: color,
    },
  });
